export default __webpack_public_path__ + "static/media/CurrentTimerIcon.89491aaf.png";